var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "studentTable" } }, [
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.currentSessionOrFirst("Students").students.length === 0,
            expression:
              "currentSessionOrFirst('Students').students.length === 0"
          }
        ],
        staticClass: "scrollable no-students"
      },
      [
        _vm.currentSession().syncStudents && !_vm.isFirstSession()
          ? _c("h6", { staticStyle: { "text-align": "center" } }, [
              _vm._v("No Students in First Session."),
              _c("br"),
              _c("span", { staticStyle: { "font-size": "10px" } }, [
                _vm._v("(Currently Synced with First Session)")
              ])
            ])
          : _vm._e(),
        !_vm.currentSession().syncStudents || _vm.isFirstSession()
          ? _c("h6", [_vm._v("No Students for this Session.")])
          : _vm._e(),
        _c(
          "span",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value:
                  _vm.canEdit &&
                  (!_vm.currentSession().syncStudents || _vm.isFirstSession()),
                expression:
                  "canEdit && (!currentSession().syncStudents || isFirstSession())"
              }
            ],
            staticClass: "label bg-primary",
            on: {
              click: function($event) {
                _vm.onAddStudent(_vm.currentSessionOrFirst("Students", true))
              }
            }
          },
          [_vm._v("Please add a Student!")]
        )
      ]
    ),
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.currentSessionOrFirst("Students").students.length > 0,
            expression: "currentSessionOrFirst('Students').students.length > 0"
          }
        ],
        staticClass: "scrollable has-students"
      },
      [
        _c(
          "div",
          { staticClass: "thead" },
          _vm._l(_vm.studentColumns, function(column, index) {
            return _c(
              "div",
              {
                key: index,
                style: {
                  "text-align": column.align,
                  flex: "0 0 " + _vm.calculatedColumnWidth(column.width),
                  "max-width": _vm.calculatedColumnWidth(column.width)
                }
              },
              [
                _c("span", [
                  _vm._v(_vm._s(column.label)),
                  column.required ? _c("span", [_vm._v("*")]) : _vm._e()
                ]),
                column.autoFillDate
                  ? _c(
                      "span",
                      [
                        _c(
                          "q-btn",
                          {
                            staticClass: "auto-fill-date",
                            attrs: {
                              color: "primary",
                              size: "sm",
                              disable:
                                !_vm.canEdit ||
                                (_vm.currentSessionOrFirst("Students")
                                  .syncStudents &&
                                  !_vm.isFirstSession()),
                              label: "Fill"
                            },
                            nativeOn: {
                              click: function($event) {
                                _vm.dateAutocomplete(
                                  _vm.currentSessionOrFirst("Students", true)
                                )
                              }
                            }
                          },
                          [
                            _vm.currentStudentSlotsAvailable() == 0
                              ? _c(
                                  "q-tooltip",
                                  {
                                    attrs: {
                                      anchor: "top middle",
                                      self: "bottom middle",
                                      offset: [10, 10]
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "\n                                   All unedited Completed On fields will be set to the current End Date\n                                "
                                    )
                                  ]
                                )
                              : _vm._e()
                          ],
                          1
                        )
                      ],
                      1
                    )
                  : _vm._e()
              ]
            )
          })
        ),
        _c(
          "div",
          { staticClass: "tbody-frozen" },
          _vm._l(_vm.currentSessionOrFirst("Students").students, function(
            student,
            index
          ) {
            return _c(
              "div",
              {
                key: index,
                staticClass: "tr",
                class: {
                  "has-error": _vm.studentHasError(index, student),
                  selected: student.selected,
                  rereport:
                    _vm.studentValidation[index].$anyDirty &&
                    _vm.sessionInformation.classStatus == 5 &&
                    student.dlState == 32
                },
                attrs: { title: _vm.studentTitle }
              },
              [
                _c(
                  "div",
                  {
                    staticClass: "td",
                    style: {
                      flex: "0 0 " + _vm.column("selected").width + "px",
                      "max-width": _vm.column("selected").width + "px"
                    }
                  },
                  [
                    _c(
                      "div",
                      [
                        _c("q-checkbox", {
                          attrs: { disable: _vm.disableIfSync || !_vm.canEdit },
                          model: {
                            value: student.selected,
                            callback: function($$v) {
                              _vm.$set(student, "selected", $$v)
                            },
                            expression: "student.selected"
                          }
                        })
                      ],
                      1
                    )
                  ]
                )
              ]
            )
          })
        ),
        _c(
          "div",
          { staticClass: "tbody" },
          _vm._l(_vm.currentSessionOrFirst("Students").students, function(
            student,
            index
          ) {
            return _c(
              "div",
              {
                key: index,
                staticClass: "tr",
                class: {
                  "has-error": _vm.studentHasError(index, student),
                  selected: student.selected,
                  rereport:
                    _vm.studentValidation[index].$anyDirty &&
                    _vm.sessionInformation.classStatus == 5 &&
                    student.dlState == 32
                },
                attrs: { title: _vm.studentTitle }
              },
              [
                _c(
                  "div",
                  {
                    staticClass: "td",
                    style: {
                      flex: "0 0 " + _vm.column("dlState").width + "px",
                      "max-width": _vm.column("dlState").width + "px"
                    }
                  },
                  [
                    _c(
                      "div",
                      { style: { width: _vm.column("dlState").width + "px" } },
                      [
                        _c(
                          "q-field",
                          [
                            _c(
                              "q-input",
                              {
                                attrs: {
                                  after: [],
                                  placeholder: "Search for DL State",
                                  disable: !_vm.canEdit,
                                  "clear-value": null,
                                  clearable: ""
                                },
                                on: {
                                  clear: function(item) {
                                    return _vm.onClearDLState(index)
                                  }
                                },
                                model: {
                                  value: student.dlStateName,
                                  callback: function($$v) {
                                    _vm.$set(student, "dlStateName", $$v)
                                  },
                                  expression: "student.dlStateName"
                                }
                              },
                              [
                                _c("q-autocomplete", {
                                  ref: "dlStateAutoComplete" + index,
                                  refInFor: true,
                                  on: {
                                    selected: function(item) {
                                      return _vm.onSelectDLState(item, index)
                                    },
                                    search: function(s, done) {
                                      return _vm.onDLStateSearch(s, done, index)
                                    }
                                  }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ]
                ),
                _c(
                  "div",
                  {
                    staticClass: "td",
                    style: { flex: "0 0 " + _vm.column("dl").width + "px" }
                  },
                  [
                    _c(
                      "div",
                      { style: { width: _vm.column("dl").width + "px" } },
                      [
                        _c(
                          "q-field",
                          {
                            attrs: {
                              error: _vm.studentValidation[index].dl.$error,
                              "error-label": _vm.driversLicenseErrorMap[index]
                            }
                          },
                          [
                            _c("q-input", {
                              ref: "dlInput" + index,
                              refInFor: true,
                              attrs: {
                                disable: _vm.disableIfSync || !_vm.canEdit,
                                value: student.dl,
                                after: [
                                  {
                                    icon: "flag",
                                    condition:
                                      _vm.studentValidation[index].dl.$invalid
                                  },
                                  {
                                    icon: "fa fa-check",
                                    condition: !_vm.studentValidation[index].dl
                                      .$invalid
                                  }
                                ]
                              },
                              on: {
                                input: function(val) {
                                  return _vm.setSessionStudentInformationMethod(
                                    {
                                      sessionIndex: _vm.currentSession(true),
                                      studentIndex: index,
                                      type: "dl",
                                      value: val
                                    }
                                  )
                                },
                                keydown: function(e) {
                                  if (e.key === "-") {
                                    e.preventDefault()
                                  }
                                },
                                blur: function($event) {
                                  _vm.$touch({
                                    sessionIndex: _vm.currentSession(true),
                                    studentIndex: index,
                                    type: "dl"
                                  })
                                }
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ]
                ),
                _c(
                  "div",
                  {
                    staticClass: "td",
                    style: {
                      flex: "0 0 " + _vm.column("lastName").width + "px"
                    }
                  },
                  [
                    _c(
                      "div",
                      { style: { width: _vm.column("lastName").width + "px" } },
                      [
                        _c(
                          "q-field",
                          {
                            attrs: {
                              error:
                                _vm.studentValidation[index].lastName.$error,
                              "error-label": "Required"
                            }
                          },
                          [
                            _c("q-input", {
                              attrs: {
                                disable: _vm.disableIfSync || !_vm.canEdit,
                                value: student.lastName,
                                after: [
                                  {
                                    icon: "flag",
                                    condition:
                                      _vm.studentValidation[index].lastName
                                        .$invalid
                                  },
                                  {
                                    icon: "fa fa-check",
                                    condition: !_vm.studentValidation[index]
                                      .lastName.$invalid
                                  }
                                ]
                              },
                              on: {
                                input: function(val) {
                                  return _vm.setSessionStudentInformationMethod(
                                    {
                                      sessionIndex: _vm.currentSession(true),
                                      studentIndex: index,
                                      type: "lastName",
                                      value: val
                                    }
                                  )
                                },
                                blur: function($event) {
                                  _vm.$touch({
                                    sessionIndex: _vm.currentSession(true),
                                    studentIndex: index,
                                    type: "lastName"
                                  })
                                }
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ]
                ),
                _c(
                  "div",
                  {
                    staticClass: "td",
                    style: {
                      flex: "0 0 " + _vm.column("firstName").width + "px"
                    }
                  },
                  [
                    _c(
                      "div",
                      {
                        style: { width: _vm.column("firstName").width + "px" }
                      },
                      [
                        _c(
                          "q-field",
                          {
                            attrs: {
                              error:
                                _vm.studentValidation[index].firstName.$error,
                              "error-label": "Required"
                            }
                          },
                          [
                            _c("q-input", {
                              attrs: {
                                disable: _vm.disableIfSync || !_vm.canEdit,
                                value: student.firstName,
                                after: [
                                  {
                                    icon: "flag",
                                    condition:
                                      _vm.studentValidation[index].firstName
                                        .$invalid
                                  },
                                  {
                                    icon: "fa fa-check",
                                    condition: !_vm.studentValidation[index]
                                      .firstName.$invalid
                                  }
                                ]
                              },
                              on: {
                                input: function(val) {
                                  return _vm.setSessionStudentInformationMethod(
                                    {
                                      sessionIndex: _vm.currentSession(true),
                                      studentIndex: index,
                                      type: "firstName",
                                      value: val
                                    }
                                  )
                                }
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ]
                ),
                _c(
                  "div",
                  {
                    staticClass: "td",
                    style: {
                      flex: "0 0 " + _vm.column("middleName").width + "px"
                    }
                  },
                  [
                    _c(
                      "div",
                      {
                        style: { width: _vm.column("middleName").width + "px" }
                      },
                      [
                        _c(
                          "q-field",
                          [
                            _c("q-input", {
                              attrs: {
                                disable: _vm.disableIfSync || !_vm.canEdit,
                                value: student.middleName
                              },
                              on: {
                                input: function(val) {
                                  return _vm.setSessionStudentInformationMethod(
                                    {
                                      sessionIndex: _vm.currentSession(true),
                                      studentIndex: index,
                                      type: "middleName",
                                      value: val
                                    }
                                  )
                                },
                                blur: function($event) {
                                  _vm.$touch({
                                    sessionIndex: _vm.currentSession(true),
                                    studentIndex: index,
                                    type: "middleName"
                                  })
                                }
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ]
                ),
                _c(
                  "div",
                  {
                    staticClass: "td",
                    style: {
                      flex: "0 0 " + _vm.column("address1").width + "px"
                    }
                  },
                  [
                    _c(
                      "div",
                      { style: { width: _vm.column("address1").width + "px" } },
                      [
                        _c(
                          "q-field",
                          {
                            attrs: {
                              error:
                                _vm.studentValidation[index].address1.$error,
                              "error-label": "Required"
                            }
                          },
                          [
                            _c("q-input", {
                              directives: [
                                {
                                  name: "places-autocomplete",
                                  rawName: "v-places-autocomplete",
                                  value: function(place) {
                                    return _vm.placeChange(place, index)
                                  },
                                  expression:
                                    "(place) => placeChange(place, index)"
                                }
                              ],
                              attrs: {
                                disable: _vm.disableIfSync || !_vm.canEdit,
                                value: student.address1,
                                after: [
                                  {
                                    icon: "flag",
                                    condition:
                                      _vm.studentValidation[index].address1
                                        .$invalid
                                  },
                                  {
                                    icon: "fa fa-check",
                                    condition: !_vm.studentValidation[index]
                                      .address1.$invalid
                                  }
                                ],
                                autocomplete: "new-password"
                              },
                              on: {
                                input: function(val) {
                                  return _vm.setSessionStudentInformationMethod(
                                    {
                                      sessionIndex: _vm.currentSession(true),
                                      studentIndex: index,
                                      type: "address1",
                                      value: val
                                    }
                                  )
                                },
                                blur: function($event) {
                                  _vm.$touch({
                                    sessionIndex: _vm.currentSession(true),
                                    studentIndex: index,
                                    type: "address1"
                                  })
                                }
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ]
                ),
                _c(
                  "div",
                  {
                    staticClass: "td",
                    style: {
                      flex: "0 0 " + _vm.column("address2").width + "px"
                    }
                  },
                  [
                    _c(
                      "div",
                      { style: { width: _vm.column("address2").width + "px" } },
                      [
                        _c("q-input", {
                          ref: "address2" + index,
                          refInFor: true,
                          attrs: {
                            disable: _vm.disableIfSync || !_vm.canEdit,
                            value: student.address2
                          },
                          on: {
                            input: function(val) {
                              return _vm.setSessionStudentInformationMethod({
                                sessionIndex: _vm.currentSession(true),
                                studentIndex: index,
                                type: "address2",
                                value: val
                              })
                            },
                            blur: function($event) {
                              _vm.$touch({
                                sessionIndex: _vm.currentSession(true),
                                studentIndex: index,
                                type: "address2"
                              })
                            }
                          }
                        })
                      ],
                      1
                    )
                  ]
                ),
                _c(
                  "div",
                  {
                    staticClass: "td",
                    style: { flex: "0 0 " + _vm.column("city").width + "px" }
                  },
                  [
                    _c(
                      "div",
                      { style: { width: _vm.column("city").width + "px" } },
                      [
                        _c(
                          "q-field",
                          {
                            attrs: {
                              error: _vm.studentValidation[index].city.$error,
                              "error-label": "Required"
                            }
                          },
                          [
                            _c("q-input", {
                              attrs: {
                                disable: _vm.disableIfSync || !_vm.canEdit,
                                value: student.city,
                                after: [
                                  {
                                    icon: "flag",
                                    condition:
                                      _vm.studentValidation[index].city.$invalid
                                  },
                                  {
                                    icon: "fa fa-check",
                                    condition: !_vm.studentValidation[index]
                                      .city.$invalid
                                  }
                                ],
                                autocomplete: "new-password"
                              },
                              on: {
                                input: function(val) {
                                  return _vm.setSessionStudentInformationMethod(
                                    {
                                      sessionIndex: _vm.currentSession(true),
                                      studentIndex: index,
                                      type: "city",
                                      value: val
                                    }
                                  )
                                },
                                blur: function($event) {
                                  _vm.$touch({
                                    sessionIndex: _vm.currentSession(true),
                                    studentIndex: index,
                                    type: "city"
                                  })
                                }
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ]
                ),
                _c(
                  "div",
                  {
                    staticClass: "td",
                    style: { flex: "0 0 " + _vm.column("stateId").width + "px" }
                  },
                  [
                    _c(
                      "div",
                      { style: { width: _vm.column("stateId").width + "px" } },
                      [
                        _c(
                          "q-field",
                          {
                            attrs: {
                              error:
                                _vm.studentValidation[index].stateId.$error,
                              "error-label": "Required"
                            }
                          },
                          [
                            _c(
                              "q-input",
                              {
                                attrs: {
                                  after: [
                                    {
                                      icon: "flag",
                                      condition:
                                        _vm.studentValidation[index].stateId
                                          .$invalid
                                    },
                                    {
                                      icon: "fa fa-check",
                                      condition: !_vm.studentValidation[index]
                                        .stateId.$invalid
                                    }
                                  ],
                                  placeholder: "State",
                                  disable: !_vm.canEdit,
                                  "clear-value": null,
                                  clearable: ""
                                },
                                model: {
                                  value: student.stateName,
                                  callback: function($$v) {
                                    _vm.$set(student, "stateName", $$v)
                                  },
                                  expression: "student.stateName"
                                }
                              },
                              [
                                _c("q-autocomplete", {
                                  ref: "stateAutoComplete" + index,
                                  refInFor: true,
                                  on: {
                                    selected: function(item) {
                                      return _vm.onSelectState(item, index)
                                    },
                                    search: function(s, done) {
                                      return _vm.onStateSearch(s, done, index)
                                    }
                                  }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ]
                ),
                _c(
                  "div",
                  {
                    staticClass: "td",
                    style: { flex: "0 0 " + _vm.column("zip").width + "px" }
                  },
                  [
                    _c(
                      "div",
                      { style: { width: _vm.column("zip").width + "px" } },
                      [
                        _c(
                          "q-field",
                          {
                            attrs: {
                              error: _vm.studentValidation[index].zip.$error,
                              "error-label": "Required"
                            }
                          },
                          [
                            _c("q-input", {
                              ref: "zip" + index,
                              refInFor: true,
                              attrs: {
                                disable: _vm.disableIfSync || !_vm.canEdit,
                                value: student.zip,
                                after: [
                                  {
                                    icon: "flag",
                                    condition:
                                      _vm.studentValidation[index].zip.$invalid
                                  },
                                  {
                                    icon: "fa fa-check",
                                    condition: !_vm.studentValidation[index].zip
                                      .$invalid
                                  }
                                ],
                                autocomplete: "new-password"
                              },
                              on: {
                                input: function(val) {
                                  return _vm.setSessionStudentInformationMethod(
                                    {
                                      sessionIndex: _vm.currentSession(true),
                                      studentIndex: index,
                                      type: "zip",
                                      value: val
                                    }
                                  )
                                },
                                blur: function($event) {
                                  _vm.$touch({
                                    sessionIndex: _vm.currentSession(true),
                                    studentIndex: index,
                                    type: "zip"
                                  })
                                }
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ]
                ),
                _c(
                  "div",
                  {
                    staticClass: "td",
                    style: { flex: "0 0 " + _vm.column("gender").width + "px" }
                  },
                  [
                    _c(
                      "div",
                      { style: { width: _vm.column("gender").width + "px" } },
                      [
                        _c(
                          "q-field",
                          {
                            attrs: {
                              error: _vm.studentValidation[index].gender.$error,
                              "error-label": "Required"
                            }
                          },
                          [
                            _c("q-select", {
                              ref: "genderDropdown" + index,
                              refInFor: true,
                              attrs: {
                                filter: "",
                                value: student.gender,
                                options: _vm.genderOptions,
                                disable: _vm.disableIfSync || !_vm.canEdit,
                                after: [
                                  {
                                    icon: "flag",
                                    condition:
                                      _vm.studentValidation[index].gender
                                        .$invalid
                                  },
                                  {
                                    icon: "fa fa-check",
                                    condition: !_vm.studentValidation[index]
                                      .gender.$invalid
                                  }
                                ]
                              },
                              on: {
                                blur: function($event) {
                                  _vm.$touch({
                                    sessionIndex: _vm.currentSession(true),
                                    studentIndex: index,
                                    type: "gender"
                                  })
                                },
                                focus: function($event) {
                                  _vm.onDropdownFocus(
                                    "genderDropdown" + index,
                                    index,
                                    "gender"
                                  )
                                },
                                change: function(val) {
                                  return _vm.setSessionStudentInformationMethod(
                                    {
                                      sessionIndex: _vm.currentSession(true),
                                      studentIndex: index,
                                      type: "gender",
                                      value: val
                                    }
                                  )
                                }
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ]
                ),
                _c(
                  "div",
                  {
                    staticClass: "td dob-field",
                    style: { flex: "0 0 " + _vm.column("dob").width + "px" }
                  },
                  [
                    _c(
                      "div",
                      { style: { width: _vm.column("dob").width + "px" } },
                      [
                        _c(
                          "q-field",
                          {
                            attrs: {
                              error: _vm.studentValidation[index].dob.$error,
                              "error-label": "MM/DD/YYYY"
                            }
                          },
                          [
                            _c("q-input", {
                              attrs: {
                                value: student.dob,
                                disable: _vm.disableIfSync || !_vm.canEdit,
                                after: [
                                  {
                                    icon: "flag",
                                    condition:
                                      _vm.studentValidation[index].dob.$invalid
                                  },
                                  {
                                    icon: "fa fa-check",
                                    condition: !_vm.studentValidation[index].dob
                                      .$invalid
                                  }
                                ]
                              },
                              on: {
                                blur: function($event) {
                                  _vm.$touch({
                                    sessionIndex: _vm.currentSession(true),
                                    studentIndex: index,
                                    type: "dob"
                                  })
                                },
                                keyup: function($event) {
                                  $event.stopPropagation()
                                  _vm.setSessionStudentInformationMethod({
                                    justSync: true,
                                    sessionIndex: _vm.currentSession(true),
                                    studentIndex: index,
                                    type: "dob",
                                    value: $event.target.value
                                  })
                                  _vm.updateStudentField({
                                    field: "dob",
                                    new: $event.target.value,
                                    session: _vm.currentSessionOrFirst(
                                      "Students",
                                      true
                                    ),
                                    index: index
                                  })
                                }
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ]
                ),
                _c(
                  "div",
                  {
                    staticClass: "td",
                    style: { flex: "0 0 " + _vm.column("phone").width + "px" }
                  },
                  [
                    _c(
                      "div",
                      { style: { width: _vm.column("phone").width + "px" } },
                      [
                        _c(
                          "q-field",
                          [
                            _c("q-input", {
                              directives: [
                                {
                                  name: "mask",
                                  rawName: "v-mask",
                                  value: "999-999-9999",
                                  expression: "'999-999-9999'"
                                }
                              ],
                              attrs: {
                                disable: _vm.disableIfSync || !_vm.canEdit,
                                value: student.phone,
                                type: "tel"
                              },
                              on: {
                                input: function(val) {
                                  return _vm.setSessionStudentInformationMethod(
                                    {
                                      sessionIndex: _vm.currentSession(true),
                                      studentIndex: index,
                                      type: "phone",
                                      value: val
                                    }
                                  )
                                }
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ]
                ),
                _c(
                  "div",
                  {
                    staticClass: "td",
                    style: { flex: "0 0 " + _vm.column("email").width + "px" }
                  },
                  [
                    _c(
                      "div",
                      { style: { width: _vm.column("email").width + "px" } },
                      [
                        _c(
                          "q-field",
                          [
                            _c("q-input", {
                              attrs: {
                                disable: _vm.disableIfSync || !_vm.canEdit
                              },
                              model: {
                                value: student.email,
                                callback: function($$v) {
                                  _vm.$set(student, "email", $$v)
                                },
                                expression: "student.email"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ]
                ),
                _c(
                  "div",
                  {
                    staticClass: "td",
                    style: {
                      flex: "0 0 " + _vm.column("completedDate").width + "px"
                    }
                  },
                  [
                    _c(
                      "div",
                      {
                        style: {
                          width: _vm.column("completedDate").width + "px"
                        }
                      },
                      [
                        _c(
                          "q-field",
                          { attrs: { "error-label": "Invalid Date" } },
                          [
                            _c("sl-date-time", {
                              attrs: {
                                disable: _vm.disableIfSync || !_vm.canEdit,
                                value: student.completedDate,
                                type: "date"
                              },
                              on: {
                                keyup: function($event) {
                                  $event.stopPropagation()
                                  return (function(newVal) {
                                    _vm.setSessionStudentInformationMethod({
                                      sessionIndex: _vm.currentSession(true),
                                      studentIndex: index,
                                      type: "completedDate",
                                      value: $event.target.value
                                    })
                                    _vm.updateStudentField({
                                      field: "completedDate",
                                      new: $event.target.value,
                                      session: _vm.currentSessionOrFirst(
                                        "Students",
                                        true
                                      ),
                                      index: index
                                    })
                                  })($event)
                                }
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ]
                )
              ]
            )
          })
        )
      ]
    ),
    _vm.canEdit
      ? _c(
          "div",
          { staticClass: "tfooter" },
          [
            _c(
              "q-btn",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: !_vm.disableIfSync && _vm.canEdit,
                    expression: "!disableIfSync && canEdit"
                  }
                ],
                class: {
                  "text-primary": !_vm.addButtonFocused,
                  "text-positive": _vm.addButtonFocused
                },
                attrs: {
                  color: "primary",
                  outline: "",
                  disable:
                    _vm.disableIfSync || _vm.currentStudentSlotsAvailable() == 0
                },
                on: {
                  click: function($event) {
                    _vm.onAddStudent(
                      _vm.currentSessionOrFirst("Students", true)
                    )
                  }
                },
                nativeOn: {
                  focus: function($event) {
                    _vm.onFocus(true)
                  },
                  blur: function($event) {
                    _vm.onBlur()
                  }
                }
              },
              [
                _vm._v(
                  "\n            " +
                    _vm._s(_vm.addStudentLabel) +
                    "\n            "
                ),
                _vm.currentStudentSlotsAvailable() == 0
                  ? _c(
                      "q-tooltip",
                      {
                        attrs: {
                          anchor: "top middle",
                          self: "bottom middle",
                          offset: [10, 10]
                        }
                      },
                      [
                        _vm._v(
                          "\n                Max Students Reached!\n            "
                        )
                      ]
                    )
                  : _vm._e()
              ],
              1
            ),
            _vm.currentSession().students.length > 0
              ? _c(
                  "q-btn",
                  {
                    attrs: {
                      outline: "",
                      icon: "fa fa-cloud-download",
                      color: "green"
                    },
                    on: {
                      click: function($event) {
                        _vm.exportStudents()
                      }
                    }
                  },
                  [_vm._v("\n             Export\n        ")]
                )
              : _vm._e(),
            _vm.selectedStudents.length > 0 &&
            _vm.currentSession().students.length > 0
              ? _c(
                  "q-btn",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: !_vm.disableIfSync && _vm.canEdit,
                        expression: "!disableIfSync && canEdit"
                      }
                    ],
                    attrs: {
                      disable: _vm.disableIfSync,
                      outline: "",
                      color: "negative"
                    },
                    on: {
                      click: function($event) {
                        _vm.removeStudentsConfirmation()
                      }
                    }
                  },
                  [_vm._v("\n            Remove Selected\n        ")]
                )
              : _vm._e(),
            _c(
              "div",
              { staticClass: "right" },
              [
                _vm.canReprocessStudents
                  ? _c(
                      "q-btn",
                      {
                        attrs: {
                          icon: "refresh",
                          outline: "",
                          color: "purple"
                        },
                        nativeOn: {
                          click: function($event) {
                            _vm.reprocessStudentsMethod(_vm.selectedStudents)
                          }
                        }
                      },
                      [_vm._v("Reprocess Certificates")]
                    )
                  : _vm._e(),
                _vm.currentSessionOrFirst("Students").maxStudents
                  ? _c("span", { staticClass: "sync-label" }, [
                      _vm._v(
                        "\n                (" +
                          _vm._s(_vm.currentStudentSlotsAvailable()) +
                          "/" +
                          _vm._s(
                            _vm.currentSessionOrFirst("Students").maxStudents
                          ) +
                          ") Slots Available\n            "
                      )
                    ])
                  : _vm._e(),
                _c(
                  "span",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: !_vm.isFirstSession() && _vm.canEdit,
                        expression: "!isFirstSession() && canEdit"
                      }
                    ],
                    staticClass: "sync-label"
                  },
                  [
                    _c("q-checkbox", {
                      attrs: { disable: !_vm.canEdit },
                      model: {
                        value: _vm.currentSession().syncStudents,
                        callback: function($$v) {
                          _vm.$set(_vm.currentSession(), "syncStudents", $$v)
                        },
                        expression: "currentSession().syncStudents"
                      }
                    }),
                    _c("span", [_vm._v("Sync with First Session")])
                  ],
                  1
                ),
                _c(
                  "q-btn-dropdown",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.showCopyButton && _vm.canEdit,
                        expression: "showCopyButton && canEdit"
                      }
                    ],
                    attrs: { label: "Copy From..", outline: "", color: "grey" }
                  },
                  [
                    _c(
                      "q-list",
                      { attrs: { link: "" } },
                      _vm._l(_vm.sessionInformation.sessions, function(
                        session,
                        index
                      ) {
                        return session.label != _vm.currentSession().label &&
                          session.students.length > 0
                          ? _c(
                              "q-item",
                              {
                                directives: [
                                  {
                                    name: "close-overlay",
                                    rawName: "v-close-overlay"
                                  }
                                ],
                                key: index,
                                nativeOn: {
                                  click: function($event) {
                                    _vm.copyStudents(index)
                                  }
                                }
                              },
                              [
                                _c("q-item-main", [
                                  _vm._v(
                                    "\n                            " +
                                      _vm._s(session.label) +
                                      "\n                        "
                                  )
                                ])
                              ],
                              1
                            )
                          : _vm._e()
                      })
                    )
                  ],
                  1
                )
              ],
              1
            )
          ],
          1
        )
      : _c(
          "div",
          { staticClass: "tfooter" },
          [
            _vm.currentSession().students.length > 0
              ? _c(
                  "q-btn",
                  {
                    attrs: {
                      outline: "",
                      icon: "fa fa-cloud-download",
                      color: "green"
                    },
                    on: {
                      click: function($event) {
                        _vm.exportStudents()
                      }
                    }
                  },
                  [_vm._v("\n             Export\n        ")]
                )
              : _vm._e()
          ],
          1
        )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }